//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: { type: Boolean, required: true },
    round: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
}
